import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { UpdateManagerSalaryDto } from '../types';

type Params = {
  salaryId: number;
  managerId: number;
  year: number;
  month: number;
  bonus: string;
  salary: string;
  additionalBonus: string;
  penalty: string;
};

export const updateManagerSalary = async ({
  salaryId,
  managerId,
  year,
  month,
  bonus,
  salary,
  additionalBonus,
  penalty,
}: Params): Promise<void> => {
  const body: UpdateManagerSalaryDto = {
    manager: managerId,
    salary,
    month,
    year,
    bonus,
    penalty,
    addinional_bonus: additionalBonus,
  };

  await api.put(
    `${PANEl_BASE_URL}/manager-salaries/manager-salaries/${salaryId}/`,
    body
  );
};

export const useUpdateManagerSalary = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateManagerSalary,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};